<template>
  <div>
    <a-table
      :columns="columns"
      :loading="loadingTable"
      :data-source="usersSummary"
      :pagination="false"
      :row-key="(user) => user.user_id"
    >
      <template #user="text, record">
        <span class="d-flex align-items-center">
          <a-avatar :src="record.gravatar" size="small" class="mr-2" />
          <router-link :to="{ name: 'user', params: { id: record.user_id } }">
            {{ text }}
          </router-link>
        </span>
      </template>
      <template #total="text">
        {{ text }}
      </template>
    </a-table>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { usersSummaryInterface } from "../types";

// Props
const props = defineProps({
  usersSummary: { type: Array as () => Array<usersSummaryInterface>, default: () => [] },
  loadingTable: { type: Boolean, default: false },
  types: { type: Array as () => Array<string>, default: () => [] },
});

const allColumns = ref<Array<usersSummaryInterface>>([
  {
    title: "User",
    dataIndex: "name",
    key: "user",
    type: "base",
    scopedSlots: { customRender: "user" },
  },
  {
    title: "Time Reports",
    dataIndex: "time_report_total",
    key: "time_report_total",
    type: "time-report",
    customRender: (text: number) => `${text} h`,
  },
  {
    title: "Sick Reports",
    dataIndex: "sick_report_total",
    key: "sick_report_total",
    type: "sick-report",
    customRender: (text: number) => `${text} days`,
  },
  {
    title: "Absence Reports",
    dataIndex: "absence_report_total",
    key: "absence_report_total",
    type: "absence-report",
    customRender: (text: number) => `${text} days`,
  },
  {
    title: "Parental Reports",
    dataIndex: "parental_report_total",
    key: "parental_report_total",
    type: "parental-report",
    customRender: (text: number) => `${text} days`,
  },
  {
    title: "Vacation Reports",
    dataIndex: "vacation_report_total",
    key: "vacation_report_total",
    type: "vacation-report",
    customRender: (text: number) => `${text} days`,
  },
]);

const columns = computed(() => {
  const { types } = props;
  return allColumns.value.filter(
    ({ type }) => type === "base" || types.length === 0 || types.includes(type)
  );
});
</script>
